import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import clone from "clone"
import times from "helpers/times"
import percentChange from "helpers/percentChange"
import numeral from "numeral"
import helpers from "helpers/helpers"
import { Line } from "react-chartjs-2"
import ImageExport from "components/ImageExport"
import GroupedBar from "components/GroupedBar"
import classnames from "classnames"
import Switch from "react-switch"
import { updateDates, getPayload } from "actions"
import FullTable from "components/FullTable"
import colorArray from "helpers/colorArray"
//import Group from "react-select/src/components/Group"

class SalesVariance extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			showProjections: true,
			times: times(),
			activeYears: [moment().year().toString()],
			columns: [
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Annual Goal",
					accessor: "Annual Goal",
					Cell: (v) => {
						if (v.value) {
							return v.value
						}
						return 0
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["Annual Goal"]) {
								total += v["Annual Goal"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Cumulative Projected YTD",
					accessor: "Cumulative Projected YTD",
					Cell: (v) => {
						if (v.value) {
							return v.value
						}
						return 0
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (v["Cumulative Projected YTD"]) {
								total += v["Cumulative Projected YTD"]
							}
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Cumulative Net YTD",
					accessor: "Cumulative Net YTD",
					Cell: (v) => {
						if (v.value) {
							return v.value
						}
						return 0
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["Cumulative Net YTD"]
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Variance",
					accessor: "Variance",
					Cell: (r, pdf) => {
						if (pdf === true) {
							return r.value
						}
						if (Math.sign(r.value) == 1) {
							return <span className="darkGreen bold">{`+${r.value}`}</span>
						} else if (Math.sign(r.value) == -1) {
							return <span className="red bold">{`${r.value}`}</span>
						} else {
							return 0
						}
					},
					Footer: (props, pdf) => {
						let total = 0
						_.forEach(props.data, (v) => {
							if (!v["Variance"]) {
								return
							}
							total += v["Variance"]
						})
						if (pdf === true) {
							return total
						}
						if (Math.sign(total) == 1) {
							return <span className="darkGreen bold">{`+${total}`}</span>
						} else if (Math.sign(total) == -1) {
							return <span className="red bold">{`${total}`}</span>
						} else {
							return 0
						}
					},
				},
				{
					Header: "Variance %",
					accessor: "Variance %",
					Cell: (r, pdf) => {
						if (pdf === true) {
							return numeral(r.value / 100).format("0,0%")
						}
						if (Math.sign(r.value) == 1) {
							return <span className="darkGreen bold">{`+${r.value}%`}</span>
						} else if (Math.sign(r.value) == -1) {
							return <span className="red bold">{`${r.value}%`}</span>
						} else {
							return 0
						}
					},
					Footer: (props, pdf) => {
						let a = 0
						let p = 0
						_.forEach(props.data, (v) => {
							a += v["Cumulative Net YTD"]
							p += v["Cumulative Projected YTD"]
						})
						let total = percentChange(p, a)
						total = total / 100
						if (pdf === true) {
							return numeral(total).format("0.00%")
						}
						//let total = Math.round(percentChange(projected, actual))
						if (Math.sign(total) == 1) {
							return <span className="darkGreen bold">{`+${numeral(total).format("0.00%")}`}</span>
						} else if (Math.sign(total) == -1) {
							return <span className="red bold">{`${numeral(total).format("0.00%")}`}</span>
						} else {
							return 0
						}
					},
				},
			],
			sorted: [],
			cumulativeShowLabels: true,
		}
	}

	componentDidMount() {
		let f = {
			startDate: moment().startOf("year"),
			endDate: moment(),
		}
		this.props.updateDates(f)
		this.props.getPayload()
	}

	filterChange = (e) => {
		let state = clone(this.state)
		state.filters[e.target.value] = !state.filters[e.target.value]
		this.setState(state)
	}

	toggleAll = (checked) => {
		let filters = clone(this.state.filters)
		_.forEach(filters, (v, k) => {
			filters[k] = checked
		})
		this.setState({ filters: filters })
	}

	buildTable() {
		let store = {
			sales: {},
			busts: {},
			projections: {}, // for ytd
			projectionIDs: {},
			yearProjections: {}, // for the entire year,
			variance: {},
			variancePercent: {},
			annual: {},
		}
		let times = {
			startStamp: this.props.currentDates.startStamp,
			endStamp: this.props.currentDates.endStamp,
			startMonth: moment.unix(this.props.currentDates.startStamp).format("M"),
			startYear: moment.unix(this.props.currentDates.startStamp).format("YYYY"),
			endMonth: moment.unix(this.props.currentDates.endStamp).format("M"),
			endYear: moment.unix(this.props.currentDates.endStamp).format("YYYY"),
			startDay: moment.unix(this.props.currentDates.startStamp).date(),
			endDay: moment.unix(this.props.currentDates.endStamp).date(),
		}
		// All lot types of this property
		let types = _.uniqBy(this.props.payload.exec.projections, (r) => r.lot_type)
		types = _.map(types, (v) => v.lot_type)
		_.forEach(types, (v) => {
			store.projectionIDs[v] = 0
		})
		// Build out all the lot types
		_.forEach(this.props.payload.exec.yearProjections, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) return
			let path = `sales.${type.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
		})

		// Compile sales
		_.forEach(this.props.payload.sales.current, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			let path = `sales.${type.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			path = `projections.${type.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			store.sales[type.name]++
		})

		_.forEach(this.props.payload.bustouts.current, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			let path = `busts.${type.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			path = `projections.${type.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			store.busts[type.name]++
		})
		// Subtract busts from sales
		_.forEach(this.props.payload.bustouts.current, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			let path = `sales.${type.name}`
			if (_.has(store, path)) {
				store.sales[type.name] = store.sales[type.name] - 1
			}
		})
		_.forEach(store.projectionIDs, (v, k) => {
			k = parseInt(k)
			let type = _.find(this.props.payload.public.lot_types, { id: k })
			let currentMonth = moment().month() + 1
			let currentYear = moment().year()
			if (!type) {
				return
			}
			let path = `projections.${type.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			let projections = []
			_.forEach(this.props.payload.exec.projections, (r) => {
				if (!this.props.activeProperties.includes(r.property) || r.lot_type !== k) {
					return
				}
				// Annual projections - projectionID's was being used a shell, so using it to store annual projections.  Looking at the start year, not when it ends.
				let year = moment.unix(this.props.currentDates.startStamp).year()
				if (r.year == year) store.projectionIDs[r.lot_type] += r.projection
				//
				let row = _.clone(r)
				let startMonth = moment(`${r.year}-${r.month}`, "YYYY-MM").unix()
				let endMonth = moment(`${r.year}-${r.month}`, "YYYY-MM").endOf("month").unix()
				//									 July 2020		December 2020
				if (
					r.month !== currentMonth &&
					r.year !== currentYear &&
					(startMonth < times.startStamp || endMonth > times.endStamp)
				) {
					return
				}

				// This projection is between the start and end stamp, so include it in full
				if (startMonth >= times.startStamp && endMonth <= times.endStamp) {
					projections.push(row)
				}
				// Reduce by day
				else if (r.month == times.startMonth && r.year == times.startYear) {
					//console.log('%c' + `Reducing by day, start`, 'background: #222; color: #bada55')
					let perDay = r.projection / 30
					row.projection = Math.round(perDay * times.endDay)
					projections.push(row)
				} else if (r.month == times.endMonth && r.year == times.endYear) {
					//console.log('%c' + `Reducing by day, end`, 'background: #222; color: #bada55')
					let perDay = r.projection / 30
					row.projection = Math.round(perDay * times.endDay)
					projections.push(row)
				}
			})
			_.forEach(projections, (p) => {
				store.projections[type.name] += p.projection
			})
		})
		//console.log(store)
		// sales is now net..

		_.forEach(store.projectionIDs, (v, k) => {
			let type = _.find(this.props.payload.public.lot_types, { id: parseInt(k) })
			if (!type) {
				return
			}
			store.annual[type.name] = v
		})
		// calculate variances
		_.forEach(store.sales, (v, k) => {
			let path = `variance.${k}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			if (!isNaN(v) && !isNaN(store.projections[k])) {
				store.variance[k] = v - store.projections[k]
				if (store.variance[k] == 0) {
					store.variancePercent[k] = 0
				} else if (store.projections[k] == 0 && v > 0) {
					store.variancePercent[k] = v * 100
				} else {
					store.variancePercent[k] = Math.round(percentChange(store.projections[k], v))
				}
			} else {
				console.log(k)
				console.log(store.projections)
				console.log(v)
			}
		})
		// Create table rows
		//console.log(store)
		let test = 0
		_.forEach(store.variance, (v) => {
			test += v
		})
		//console.log(test)
		let rows = []
		_.forEach(store.sales, (v, k) => {
			rows.push({
				"Lot Type": k,
				"Annual Goal": store.annual[k],
				"Cumulative Projected YTD": store.projections[k],
				"Cumulative Net YTD": store.sales[k],
				Variance: store.variance[k],
				"Variance %": store.variancePercent[k],
			})
		})

		return rows
	}

	salesVariance = () => {
		let property = this.props.activeProperties[0]
		// Used inprojections and reducebyDay stuff.
		let times = {
			startStamp: this.props.currentDates.startStamp,
			endStamp: this.props.currentDates.endStamp,
			startMonth: parseInt(moment.unix(this.props.currentDates.startStamp).format("M")),
			startYear: parseInt(moment.unix(this.props.currentDates.startStamp).format("YYYY")),
			endMonth: parseInt(moment.unix(this.props.currentDates.endStamp).format("M")),
			endYear: parseInt(moment.unix(this.props.currentDates.endStamp).format("YYYY")),
			startDay: parseInt(moment.unix(this.props.currentDates.startStamp).date()),
			endDay: parseInt(moment.unix(this.props.currentDates.endStamp).date()),
		}
		let ret = {
			Projected: [],
			Net: [],
		}
		let labels = []
		let model = {
			projected: 0,
			gross: 0,
			cancels: 0,
			net: 0,
			id: 0,
		}
		let lotTypes = _.filter(this.props.payload.public.lot_types, (v) => {
			return v.property == property
		})
		let b = {}
		_.forEach(lotTypes, (v) => {
			//labels.push(v.name)
			b[v.name] = _.clone(model)
			b[v.name].id = v.id
		})
		_.forEach(this.props.payload.sales.current, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type || !b[type.name]) return
			b[type.name].gross++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type || !b[type.name]) return
			b[type.name].cancels++
		})
		_.forEach(b, (v) => {
			v.net = v.gross - v.cancels
			let currentMonth = moment().month() + 1
			let currentYear = moment().year()
			// Get projections for this lot type between start and end date
			let projections = []
			_.forEach(this.props.payload.exec.projections, (r) => {
				let row = _.clone(r)
				if (!this.props.activeProperties.includes(r.property) || r.lot_type !== v.id) {
					return
				}
				let startMonth = moment(`${r.year}-${r.month}`, "YYYY-MM").unix()
				let endMonth = moment(`${r.year}-${r.month}`, "YYYY-MM").endOf("month").unix()
				// This projection is between the start and end stamp, so include it in full
				if (
					r.month !== currentMonth &&
					r.year !== currentYear &&
					(startMonth < times.startStamp || endMonth > times.endStamp)
				) {
					return
				}
				if (startMonth >= times.startStamp && endMonth <= times.endStamp) {
					projections.push(row)
				}
				// Reduce by day
				else if (r.month == times.startMonth && r.year == times.startYear) {
					//console.log("%c" + `Reducing by day, start - ${r.projection}`, "background: #222; color: #bada55")
					let perDay = r.projection / 30
					row.projection = Math.round(perDay * times.endDay)
					projections.push(row)
				} else if (r.month == times.endMonth && r.year == times.endYear) {
					//console.log("%c" + `Reducing by day, end`, "background: #222; color: #bada55")
					let perDay = r.projection / 30
					row.projection = Math.round(perDay * times.endDay)
					projections.push(row)
				}
			})
			_.forEach(projections, (p) => {
				v.projected += p.projection
			})
		})
		_.forEach(b, (v, k) => {
			labels.push(k)
			ret.Projected.push(v.projected)
			ret["Net"].push(v.net)
		})
		let net = helpers.orderByLotType(labels, ret["Net"])
		let projected = helpers.orderByLotType(labels, ret.Projected)
		let series = [
			{
				data: projected.data,
				name: "Projected",
			},
			{
				data: net.data,
				name: "Net",
			},
		]

		return <GroupedBar categories={net.labels} series={series} />
	}

	yearAction = (v) => {
		let years = _.xor(this.state.activeYears, [v])
		this.setState({ activeYears: years })
		//chartData()
	}

	cumulativeSales = () => {
		//? If projections are off on this, it's due to rounding.  We do month based projections, and at the end of the year all the rounding will throw the final numbers off.
		let year = moment.unix(this.props.currentDates.startStamp).year()
		//let years = [year - 1, year]
		let salesTotals = this.props.payload.allSalesTotalsByWeek
		// Prior to this, an entire year would only go to 30-40 weeks because it wasn't accounting for weeks with no activity:
		//? Go through each year and ensure weeks 1 - 53 are there, even if it's all 0's
		_.forEach(salesTotals, (v, year) => {
			for (let i = 1; i <= 53; i++) {
				if (!salesTotals[year][i]) {
					_.setWith(salesTotals, `${year}.${i}`, { net: 0, projected: 0 }, Object)
				}
			}
		})
		let years = Object.keys(this.props.payload.allSalesTotalsByWeek)
		years = _.reverse(years)
		let ret = {}
		_.forEach(years, (v) => {
			ret[`${v} Net`] = []
		})
		ret[`${year} Projected`] = []

		let labels = _.range(1, 53)
		_.forEach(years, (y) => {
			if (_.has(this.props.payload, `allSalesTotalsByWeek.${y}`)) {
				_.forEach(this.props.payload.allSalesTotalsByWeek[y], (r) => {
					let last = _.last(ret[[`${y} Net`]]) || 0
					ret[[`${y} Net`]].push(last + r.net)
					if (year == y) {
						// current year for projections
						let last = _.last(ret[[`${y} Projected`]]) || 0
						let val = (r.projected + last).toFixed(2)
						val  = parseFloat(val)
						ret[[`${y} Projected`]].push(val)
					}
				})
			}
		})
		// If viewing current year, chop off the weeks in the future
		if (year == moment().year() && ret[`${year} Net`]) {
			let currentWeek = moment().isoWeek()
			ret[`${year} Net`].length = currentWeek - 1
		}
		let opts = {
			tooltips: {
				callbacks: {
					label: function (tooltipItem, data) {
						if (data.datasets[tooltipItem.datasetIndex].label.includes("Projected")) {
							return null
						}
						return tooltipItem.yLabel
					},
				},
			},
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							//beginAtZero: true,
						},
					},
				],
			},
			plugins: {
				datalabels: this.state.cumulativeShowLabels
					? { clamp: true, anchor: "end", align: "end", offset: 5 }
					: false,
			},
		}
		let i = 0
		let datasets = []
		_.forEach(ret, (v, k) => {
			if (!this.state.activeYears.includes(k.split(" ")[0]) || k.includes("Projected")) return
			i++
			datasets.push({
				label: k,
				data: v,
				borderColor: colorArray[i],
				backgroundColor: colorArray[i],
				fill: false,
			})
		})
		if (this.state.showProjections) {
			datasets.push({
				label: `${year} Projected`,
				data: ret[`${year} Projected`],
				borderColor: "#000",
				backgroundColor: "#000",
				fill: false,
				datalabels: {
					//display: false,
				},
				tooltips: false,
			})
		}
		const data = {
			labels: labels,
			datasets,
		}
		//console.log(data)
		return (
			<>
				<div className="yearList flex justify-between">
					<ul className="yearList__list py-3" data-html2canvas-ignore="true">
						{_.map(years, (v) => {
							return (
								<li
									key={v}
									className={classnames("yearList__item", {
										active: this.state.activeYears.includes(v),
									})}
									onClick={() => {
										this.yearAction(v)
									}}>
									{v}
								</li>
							)
						})}
					</ul>
					<div className="flex">
						<Switch
							onChange={() => this.setState({ cumulativeShowLabels: !this.state.cumulativeShowLabels })}
							checked={this.state.cumulativeShowLabels}
							checkedIcon={false}
							uncheckedIcon={false}
							key={"switch"}
							id={"switch"}
							height={20}
							width={40}
						/>
						<p className="!text-xs !ml-2 text-blue font-bold">Show Labels</p>
					</div>
				</div>
				<Line data={data} options={opts} />
			</>
		)
	}

	render() {
		if (this.props.activeProperties.length !== 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to administer.</h1>
				</div>
			)
		} else if (!this.props.payloadStatus) {
			return ""
		} else if (
			moment.unix(this.props.currentDates.startStamp).year() !==
			moment.unix(this.props.currentDates.endStamp).year()
		) {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Sales Variance" years={true} />
						<div className="lotStatus__pleaseChoose">
							<h1 style={{ marginTop: 100, fontSize: "30px" }}>
								Please choose one year from the datepicker above.
							</h1>
						</div>
					</div>
				</div>
			)
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Sales Variance" years={true} />
						<div className="content">
							<ImageExport name="SalesVariance" />
							<h3 className="statBox__title">Sales By Lot Type</h3>
							{this.salesVariance()}
						</div>
						<div className="content">
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="salesVariance"
								title="Sales Variance"
							/>
						</div>
						<div className="content">
							<ImageExport name="SalesVariance" />
							<h3>Cumulative Sales Analysis</h3>
							<div
								className="switch content pl-0"
								style={{ marginBottom: 15 }}
								data-html2canvas-ignore="true"
								onClick={(e) => e.stopPropagation()}>
								<Switch
									onChange={() => this.setState({ showProjections: !this.state.showProjections })}
									checked={this.state.showProjections}
									checkedIcon={false}
									uncheckedIcon={false}
									key={"switch"}
									id={"switch"}
								/>
								<p>Show Projections {this.state.showProjections ? "On" : "Off"}</p>
							</div>
							{this.cumulativeSales()}
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			updateDates,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(SalesVariance)
